import {environment} from "../../../../../environments/environment";

export interface MenuGroup {
  title: string;
  expanded: boolean;
  icon: string;
  items: MenuItem[];
}

export interface MenuItem {
  title: string;
  icon: string;
  link: string;
  selected: boolean;
  children: MenuItem[];
  permissions: string[];
}

enum Permissions {
  CAN_ORDER = "CAN_ORDER",
  CAN_START_PROCESSING = "CAN_START_PROCESSING",
  CAN_ACCESS_CUSTOMER_RECORDS = "CAN_ACCESS_CUSTOMER_RECORDS",
  CAN_MANAGE_CUSTOMERS = "CAN_MANAGE_CUSTOMERS",
  CAN_CANCEL_ORDER = "CAN_CANCEL_ORDER",
  CAN_CONFIRM_ORDER = "CAN_CONFIRM_ORDER",
  CAN_DELIVER = "CAN_DELIVER",
  CAN_MANAGE_INVENTORY = "CAN_MANAGE_INVENTORY",
  CAN_MANAGE_HR = "CAN_MANAGE_HR",
  CAN_MANAGE_TASKS = "CAN_MANAGE_TASKS",
  CAN_ACCESS_CRM = "CAN_ACCESS_CRM",
  ADMINISTRATION = "ADMINISTRATION",
  MANAGE_WEBSITE = "MANAGE_WEBSITE",
  ACCESS_USER_RESOURCES = "ACCESS_USER_RESOURCES",
  CAN_TAKE_EXAM = "CAN_TAKE_EXAM",
  VIEW_ORGANIZATIONS = "VIEW_ORGANIZATIONS",
  MANAGE_ORGANIZATION = "manage-org",
  MANAGE_BILLING = "manage-billing"
}

export const translations = {
  'Dashboard': $localize`:@@label.Dashboard:Dashboard`,
  'Sales Dashboard': $localize`:@@label.SalesDashboard:Sales Dashboard`,
  'Teacher Dashboard': $localize`:@@label.TeacherDashboard:Teacher Dashboard`,
  'Inventory': $localize`:@@label.Inventory:Inventory`,
  'Stocks': $localize`:@@label.Stocks:Stocks`,
  'Products': $localize`:@@label.Products:Products`,
  'Categories': $localize`:@@label.Categories:Categories`,
  'Brands': $localize`:@@label.Brands:Brands`,
  'Variations': $localize`:@@label.Variations:Variations`,
  'Sales': $localize`:@@label.Sales:Sales`,
  'Orders': $localize`:@@label.Orders:Orders`,
  'Customers': $localize`:@@label.Customers:Customers`,
  'My Contents': $localize`:@@label.MyContents:My Contents`,
  'Uploaded Files': $localize`:@@label.UploadedFiles:Uploaded Files`,
  'PollBox': $localize`:@@label.PollBox:PollBox`,
  'Questionnaires': $localize`:@@label.Questionnaires:Questionnaires`,
  'Answers': $localize`:@@label.Answers:Answers`,
  'Polls': $localize`:@@label.Polls:Polls`,
  'Poll Options': $localize`:@@label.PollOptions:Poll Options`,
  'Votes': $localize`:@@label.Votes:Votes`,
  'Filterable Attributes': $localize`:@@label.Filterable Attributes:Filterable Attributes`,
  'Stores': $localize`:@@label.Stores:Stores`,
  'My Wallet': $localize`:@@label.My Wallet:My Wallet`,
  'Validation Tokens': $localize`:@@label.ValidationTokens:Validation Tokens`,
  'Activity Logs': $localize`:@@label.ActivityLogs:Activity Logs`,
  'Location Types': $localize`:@@label.LocationTypes:Location Types`,
  'Crud Examples': $localize`:@@label.CrudExamples:Crud Examples`,
  'Specifications': $localize`:@@label.Specifications:Specifications`,
  'Astha': $localize`:@@label.Astha:Astha`,
  'Social': $localize`:@@label.Social:Social`,
  'Notifications': $localize`:@@label.Notifications:Notifications`,
  'Feedbacks': $localize`:@@label.Feedbacks:Feedbacks`,
  'Wallet': $localize`:@@label.Wallet:Wallet`,
  'Administration': $localize`:@@label.Administration:Administration`,
  'Labels': $localize`:@@label.Labels:Labels`,
  'Users': $localize`:@@label.Users:Users`,
  'Lockouts': $localize`:@@label.Lockouts:Lockouts`,
  'Locations': $localize`:@@label.Locations:Locations`,
  'Addresses': $localize`:@@label.Addresses:Addresses`,
  'Search..': $localize`:@@label.Search:Search`,
  'Enter Quantity': $localize`:@@hint.EnterQuantity:Enter Quantity`,
  'Unit Price': $localize`:@@hint.UnitPrice:Unit Price`,
  'Enter Retail Price': $localize`:@@hint.RetailPrice:Enter Retail Price`,
  'Enter Discount': $localize`:@@hint.Discount':Enter Discount`,
  'Enter Cashback (%)': $localize`:@@hint.Cashback:Enter Cashback (%)`,
  'Enter Name': $localize`:@@hint.Name:Enter Name`,
  'Enter Title': $localize`:@@hint.Title:Enter Title`,
  'Images': $localize`:@@hint.Images:Images`,
  'Image': $localize`:@@hint.Image:Image`,
  'Search Brand': $localize`:@@hint.SearchBrand:Search Brand`,
  'Search Category..': $localize`:@@hint.SearchCategory:Search Category..`,
  'Search Variations..': $localize`:@@hint.SearchVariations:Search Variations..`,
  'Search Attributes..': $localize`:@@hint.SearchAttributes:Search Attributes..`,
  'Search Customer..': $localize`:@@hint.SearchCustomer:Search Customer..`,
  'Search Stock..': $localize`:@@hint.SearchStock:Search Stock..`,
  'Enter Phone': $localize`:@@hint.Phone:Enter Phone`,
  'Search Store..': $localize`:@@hint.SearchStore:Search Store..`,
  'Enter Description': $localize`:@@hint.Description:Enter Description`,
  'Logo': $localize`:@@label.Logo:Logo`,
  'Select File': $localize`:@@hint.SelectFile:Select File`,
  'Feedback Actions': $localize`:@@hint.FeedbackActions:Feedback Actions`,
  'Upsert': $localize`:@@label.Upsert:Upsert`,
  'My Sales': $localize`:@@label.MySales:My Sales`,
  'Products in Stock': $localize`:@@label.ProductsInStock:Products in Stock`,
  'All Products': $localize`:@@label.AllProducts:All Products`,
  'My Customers': $localize`:@@label.MyCustomers:My Customers`,
  '$': $localize`:@@label.CurrencySymbol:$`,
  'Total Paid': $localize`:@@label.TotalPaid:Total Paid`,
  'Total Due': $localize`:@@label.TotalDue:Total Due`,
  'Add Stock': $localize`:@@label.AddStock:Add Stock`,
  'Sell': $localize`:@@label.DoSell:Sell`,
  'Print Barcode': $localize`:@@label.PrintBarcode:Print Barcode`,
  'Amount': $localize`:@@label.Amount:Amount`,
  'Month': $localize`:@@label.Month:Month`,
  'Last 1 year': $localize`:@@label.Last1Year:Last 1 year`,
  'Total Sales': $localize`:@@label.TotalSales:Total Sales`,
  'Total Investment': $localize`:@@label.TotalInvestment:Total Investment`,
  'Successful': $localize`:@@label.Successful:Successful`,
  'Error': $localize`:@@label.Error:Error`,
  'Failed!': $localize`:@@label.Failed:Failed!`,
  'Order is deleted.': $localize`:@@msg.OrderDeleted:Order is deleted.`,
  'Order has been canceled.': $localize`:@@msg.OrderCanceled:Order has been canceled.`,
  'Order has been confirmed.': $localize`:@@msg.OrderConfirmed:Order has been confirmed.`,
  'Do you want to print the receipt?': $localize`:@@msg.PrintReceipt:Do you want to print the receipt?`,
  'Are you sure you want to cancel this order?': $localize`:@@msg.ConfirmCancelOrder:Are you sure you want to cancel this order?`,
  'Unpaid order must have a customer. This will help you track the payment and get paid later on.': $localize`:@@msg.UnpaidOrderCustomer:Unpaid order must have a customer. This will help you track the payment and get paid later on.`,
  'Customer is required': $localize`:@@msg.CustomerRequired:Customer is required`,
  'Enter SKU': $localize`:@@hint.EnterSku:Enter SKU`,
  'Enter Email': $localize`:@@hint.EnterEmail:Enter Email`,
  'Note': $localize`:@@label.Note:Note`,
  'History': $localize`:@@label.History:History`,
  'Units': $localize`:@@label.Units:Units`,
  'Attributes': $localize`:@@label.Attributes:Attributes`,
  'Organization': $localize`:@@label.Organization:Organization`,
  'Employees': $localize`:@@label.Employees:Employees`,
  'Stages': $localize`:@@label.Stages:Stages`,
  'HumanResources': $localize`:@@label.HumanResources:Human Resources`,
  'CRM': $localize`:@@label.CRM:CRM`,
  'Leads': $localize`:@@label.Leads:Leads`,
  'Propagations': $localize`:@@label.Propagations:Propagations`,
  'Activities': $localize`:@@label.Activities:Activities`,
  'Campaigns': $localize`:@@label.Campaign:Campaigns`,
  'WillGetBackSoon': $localize`:@@msg.WillGetBackSoon:Thank you for your interest. We will get back to you soon.`,
  'NameValidation': $localize`:@@msg.NameValidation:Name should be at least 3 characters`,
  'PhoneValidation': $localize`:@@msg.PhoneValidation:Phone should be at exactly 11 characters!`,
  'BTValidation': $localize`:@@msg.BTValidation:Business Type should be at least 3 characters!`,
  'BusinessType': $localize`:@@hint.BusinessType:Please enter your business type!`,
  'SelectIngredient': $localize`:@@hint.SelectIngredient:Select Ingredient`,
  'CompositeStockWarning': $localize`:@@msg.CompositeStockWarning:"Ingredients must not be empty"`,
  'StocksAndMenuItems': $localize`:@@label.StocksAndMenuItems:Stocks/MenuItems`,
  'OrderPending': $localize`:@@label.OrderPending:Pending/Initiated`,
  'OrderConfirmed': $localize`:@@label.OrderConfirmed:Confirmed/Served`,
  'OrderCanceled': $localize`:@@label.OrderCanceled:Canceled`,
  'ConfirmLineVoid': $localize`:@@label.ConfirmLineVoid:This order will be canceled and a new order will be created with the same items. Are you sure?`,
  'Task': $localize`:@@label.Task:Task`,
  'TaskManagement': $localize`:@@label.TaskManagement:Task Management`,
  'State': $localize`:@@label.State:State`,
  'Board': $localize`:@@label.Board:Board`,
  'MenuItems': $localize`:@@label.MenuItems:Menu Items`,
  'TaskAssignment': $localize`:@@label.TaskAssignment:Assignments`,
  'Search Histories': $localize`:@@label.SearchHistories:Search Histories`,
  'BannerImage': $localize`:@@label.BannerImage:Banner Image`,
  'Blog': $localize`:@@label.Blog:Blog`,
  'Category': $localize`:@@label.Category:Category`,
  'BlogPost': $localize`:@@label.BlogPost:Blog Post`,
  'FeaturedImage': $localize`:@@label.FeaturedImage:Featured Image`,
  'BlogMenu': $localize`:@@label.BlogMenu:Blog Menu`,
  'Menu': $localize`:@@label.Menu:Menu`,
  'Article': $localize`:@@label.Article:Article`,
  'Website': $localize`:@@label.Website:Website`,
  'Web': $localize`:@@label.Web:Web`,
  'Webpage': $localize`:@@label.Webpage:Webpage`,
  'Q/A Platform': $localize`:@@label.QAPlatform:Q/A Platform`,
  'Privileges': $localize`:@@label.Privileges:Privileges`,
  'Question': $localize`:@@label.Question:Question`,
  'AllowedDomains': $localize`:@@label.AllowedDomains:Allowed Domains`,
  'Post': $localize`:@@label.Post:Post`,
  'Questionnaire Revisions': $localize`:@@label.QuestionnaireRevision:Questionnaire Revisions`,
  'Client Apps': $localize`:@@label.ClientApps:Client Apps`,
  'Icon': $localize`:@@label.Icon:Icon`,
  'Badge': $localize`:@@label.Badge:Badge`,
  'Gamification': $localize`:@@label.Gamification:Gamification`,
  'Transaction Categories': $localize`:@@label.TransactionCategories:Transaction Categories`,
  'Billing': $localize`:@@label.Billing:Billing`,
  'Gateways': $localize`:@@label.Gateways:Gateways`,
  'Routing Rules': $localize`:@@label.RoutingRules:Routing Rules`,
  'Billing Customers': $localize`:@@label.BillingCustomers:Billing Customers`,
  'Transactions': $localize`:@@label.Transactions:Transactions`,
  'API Keys': $localize`:@@label.ApiKeys:API Keys`,
  'ContentTemplates': $localize`:@@label.ContentTemplates:Content Templates`,
  'PreparedContents': $localize`:@@label.PreparedContents:Prepared Contents`,
  'Invoices': $localize`:@@label.Invoices:Invoices`,
  'Quality Assurance': $localize`:@@label.QualityAssurance:Quality Assurance`,
  'E-Commerce': $localize`:@@label.ECommerce:E-Commerce`,
  'Top Banners': $localize`:@@label.TopBanners:Top Banners`,
  'CategorySerials': $localize`:@@label.CategorySerials:Home Category Serials`,
};

export const MENU: MenuGroup[] = [
  {
    title: translations['Dashboard'],
    expanded: true,
    icon: "fab fa-dashcube",
    items: [
      {
        title: translations["Teacher Dashboard"],
        icon: "bx bx-home-circle",
        link: "/dash/teacher-dashboard",
        selected: false,
        children: [],
        permissions: [
          Permissions.CAN_TAKE_EXAM
        ]
      },
      {
        title: translations["Sales Dashboard"],
        icon: "bx bx-home-circle",
        link: "/dash/sales-dashboard",
        selected: false,
        children: [],
        permissions: [
          Permissions.CAN_MANAGE_INVENTORY
        ]
      }
    ]
  },
  {
    title: translations["Q/A Platform"],
    expanded: true,
    icon: "fa fa-poll",
    items: [
      {
        title: translations["Questionnaires"],
        icon: "fa fa-poll",
        link: "/dash/questionnaires",
        selected: false,
        children: [],
        permissions: [
          Permissions.CAN_TAKE_EXAM
        ]
      }, {
        title: translations["Questionnaire Revisions"],
        icon: "fa fa-poll",
        link: "/dash/questionnaire-revisions",
        selected: false,
        children: [],
        permissions: [
          Permissions.CAN_TAKE_EXAM
        ]
      },
      {
        title: translations["Question"],
        icon: "fa fa-poll",
        link: "/dash/questions",
        selected: false,
        children: [],
        permissions: [
          Permissions.CAN_TAKE_EXAM
        ]
      },
      {
        title: translations["Poll Options"],
        icon: "fa fa-poll",
        link: "/dash/poll-options",
        selected: false,
        children: [],
        permissions: [
          Permissions.CAN_TAKE_EXAM
        ]
      },
      {
        title: translations["Answers"],
        icon: "fa fa-poll",
        link: "/dash/answers",
        selected: false,
        children: [],
        permissions: [
          Permissions.CAN_TAKE_EXAM
        ]
      }
    ]
  },
  {
    title: translations["E-Commerce"],
    expanded: true,
    icon: "fa fa-cubes",
    items: [
      {
        title: translations["CategorySerials"],
        icon: "fa fa-cubes",
        link: "/dash/ecommerce/category-serials",
        selected: false,
        children: [],
        permissions: [
          Permissions.ADMINISTRATION
        ]
      },
      {
        title: translations["Top Banners"],
        icon: "fa fa-cubes",
        link: "/dash/ecommerce/top-banners",
        selected: false,
        children: [],
        permissions: [
          Permissions.ADMINISTRATION
        ]
      },
    ]
  },
  {
    title: translations["Inventory"],
    expanded: true,
    icon: "fa fa-cubes",
    items: [
      {
        title: translations["Stocks"],
        icon: "fa fa-cubes",
        link: "/dash/inventory/stocks?menu=false",
        selected: false,
        children: [],
        permissions: [
          Permissions.CAN_MANAGE_INVENTORY
        ]
      },
      {
        title: translations["MenuItems"],
        icon: "fa fa-cubes",
        link: "/dash/inventory/stocks?menu=true",
        selected: false,
        children: [],
        permissions: [
          Permissions.CAN_MANAGE_INVENTORY
        ]
      },
      {
        title: translations["Print Barcode"],
        icon: "fa fa-cubes",
        link: "/dash/inventory/barcodes/print-barcode",
        selected: false,
        children: [],
        permissions: [
          Permissions.CAN_MANAGE_INVENTORY
        ]
      },
      {
        title: translations["Products"],
        icon: "fa fa-cubes",
        link: "/dash/inventory/products",
        selected: false,
        children: [],
        permissions: [
          Permissions.CAN_MANAGE_INVENTORY
        ]
      },
      {
        title: translations["Units"],
        icon: "fa fa-cubes",
        link: "/dash/inventory/units",
        selected: false,
        children: [],
        permissions: [
          Permissions.ADMINISTRATION
        ]
      },
      {
        title: translations["Categories"],
        icon: "fa fa-folder",
        link: "/dash/inventory/categories",
        selected: false,
        children: [],
        permissions: [
          Permissions.CAN_MANAGE_INVENTORY
        ]
      },
      {
        title: translations["Brands"],
        icon: "fa fa-tags",
        link: "/dash/inventory/brands",
        selected: false,
        children: [],
        permissions: [
          Permissions.CAN_MANAGE_INVENTORY
        ]
      },
      {
        title: translations["Variations"],
        icon: "fa fa-trademark",
        link: "/dash/inventory/variations",
        selected: false,
        children: [],
        permissions: [
          Permissions.CAN_MANAGE_INVENTORY
        ]
      },
      {
        title: translations["Specifications"],
        icon: "fa fa-cube",
        link: "/dash/inventory/product-specifications",
        selected: false,
        children: [],
        permissions: [
          Permissions.ADMINISTRATION
        ]
      },
      {
        title: translations["Filterable Attributes"],
        icon: "fa fa-filter",
        link: "/dash/inventory/filterable-attributes",
        selected: false,
        children: [],
        permissions: [
          Permissions.ADMINISTRATION
        ]
      },
      {
        title: translations["Stores"],
        icon: "fa fa-filter",
        link: "/dash/inventory/vendors?mode=user",
        selected: false,
        children: [],
        permissions: [
          Permissions.CAN_MANAGE_INVENTORY
        ]
      }
    ]
  },
  {
    title: translations["Sales"],
    expanded: true,
    icon: "fa fa-shopping-cart",
    items: [
      {
        title: translations["Orders"],
        icon: "fa fa-shopping-cart",
        link: "/dash/sales/orders",
        selected: false,
        children: [],
        permissions: [
          Permissions.CAN_START_PROCESSING
        ]
      },
      {
        title: translations["Customers"],
        icon: "fa fa-user",
        link: "/dash/sales/customers",
        selected: false,
        children: [],
        permissions: [
          Permissions.CAN_ACCESS_CUSTOMER_RECORDS,
          Permissions.CAN_MANAGE_CUSTOMERS
        ]
      }
    ]
  },
  {
    title: translations["Billing"],
    expanded: true,
    icon: "fa fa-shopping-cart",
    items: [
      {
        title: translations["API Keys"],
        icon: "fa fa-shopping-cart",
        link: "/dash/billing/api-keys",
        selected: false,
        children: [],
        permissions: [
          Permissions.MANAGE_ORGANIZATION
        ]
      },
      {
        title: translations["Gateways"],
        icon: "fa fa-shopping-cart",
        link: "/dash/billing/gateways",
        selected: false,
        children: [],
        permissions: [
          Permissions.MANAGE_ORGANIZATION
        ]
      },
      {
        title: translations["Transactions"],
        icon: "fa fa-user",
        link: "/dash/billing/transactions",
        selected: false,
        children: [],
        permissions: [
          Permissions.MANAGE_ORGANIZATION
        ]
      },
      {
        title: translations["Routing Rules"],
        icon: "fa fa-user",
        link: "/dash/billing/routing-rules",
        selected: false,
        children: [],
        permissions: [
          Permissions.MANAGE_ORGANIZATION,
        ]
      },
      {
        title: translations["Customers"],
        icon: "fa fa-user",
        link: "/dash/billing/customers",
        selected: false,
        children: [],
        permissions: [
          Permissions.MANAGE_ORGANIZATION
        ]
      },
      {
        title: translations["Invoices"],
        icon: "fas fa-file-invoice",
        link: "/dash/billing/invoices",
        selected: false,
        children: [],
        permissions: [
          Permissions.MANAGE_ORGANIZATION
        ]
      },
      {
        title: translations["ContentTemplates"],
        icon: "fas fa-file-code",
        link: "/dash/billing/content-templates",
        selected: false,
        children: [],
        permissions: [
          Permissions.MANAGE_ORGANIZATION
        ]
      },
      {
        title: translations["PreparedContents"],
        icon: "fas fa-file-alt",
        link: "/dash/billing/prepared-contents",
        selected: false,
        children: [],
        permissions: [
          Permissions.MANAGE_ORGANIZATION
        ]
      }
    ]
  },
  {
    title: translations["TaskManagement"],
    expanded: true,
    icon: "fa fa-tasks",
    items: [
      {
        title: translations["Task"],
        icon: "fas fa-tag",
        link: "/dash/tasks",
        selected: false,
        children: [],
        permissions: [
          Permissions.CAN_MANAGE_TASKS
        ]
      },
      {
        title: translations["State"],
        icon: "fas fa-tag",
        link: "/dash/task-states",
        selected: false,
        children: [],
        permissions: [
          Permissions.CAN_MANAGE_TASKS
        ]
      },
      {
        title: translations["Board"],
        icon: "fas fa-tag",
        link: "/dash/boards",
        selected: false,
        children: [],
        permissions: [
          Permissions.CAN_MANAGE_TASKS
        ]
      },
      {
        title: translations["TaskAssignment"],
        icon: "fas fa-tag",
        link: "/dash/task-assignments",
        selected: false,
        children: [],
        permissions: [
          Permissions.CAN_MANAGE_TASKS
        ]
      },
    ]
  },
  {
    title: translations["HumanResources"],
    expanded: true,
    icon: "fa fa-user",
    items: [
      {
        title: translations["Employees"],
        icon: "fa fa-user",
        link: "/dash/hr/employees",
        selected: false,
        children: [],
        permissions: [
          Permissions.CAN_MANAGE_HR
        ]
      }
    ]
  },
  {
    title: translations["CRM"],
    expanded: true,
    icon: "fa fa-envelope",
    items: [
      {
        title: translations["Stages"],
        icon: "fa fa-user",
        link: "/dash/sales/stages",
        selected: false,
        children: [],
        permissions: [
          Permissions.CAN_ACCESS_CRM,
        ]
      },
      {
        title: translations["Leads"],
        icon: "fa fa-user",
        link: "/dash/sales/leads",
        selected: false,
        children: [],
        permissions: [
          Permissions.CAN_ACCESS_CRM
        ]
      },
      {
        title: translations["Activities"],
        icon: "fa fa-user",
        link: "/dash/sales/lead-propagations",
        selected: false,
        children: [],
        permissions: [
          Permissions.CAN_ACCESS_CRM
        ]
      },
      {
        title: translations["Campaigns"],
        icon: "fa fa-user",
        link: "/dash/sales/acquisition-campaigns",
        selected: false,
        children: [],
        permissions: [
          Permissions.CAN_ACCESS_CRM
        ]
      }
    ]
  },
  {
    title: translations["My Contents"],
    expanded: true,
    icon: "fa fa-file",
    items: [
      {
        title: translations["Uploaded Files"],
        icon: "fa fa-file",
        link: "/cms/files",
        selected: false,
        children: [],
        permissions: [
          Permissions.CAN_MANAGE_INVENTORY,
          Permissions.ACCESS_USER_RESOURCES
        ]
      }
    ]
  },
  {
    title: translations["Web"],
    expanded: true,
    icon: "fa fa-globe",
    items: [
      {
        title: translations["Website"],
        icon: "fa fa-file",
        link: "/dash/web/websites",
        selected: false,
        children: [],
        permissions: [
          Permissions.MANAGE_WEBSITE,
        ]
      },
      {
        title: translations["Menu"],
        icon: "fa fa-file",
        link: "/dash/web/blog-menus",
        selected: false,
        children: [],
        permissions: [
          Permissions.MANAGE_WEBSITE,
        ]
      },
      {
        title: translations["Category"],
        icon: "fa fa-file",
        link: "/dash/web/article-categories",
        selected: false,
        children: [],
        permissions: [
          Permissions.MANAGE_WEBSITE
        ]
      },
      {
        title: translations["Article"],
        icon: "fa fa-file",
        link: "/dash/web/articles",
        selected: false,
        children: [],
        permissions: [
          Permissions.MANAGE_WEBSITE
        ]
      },
      {
        title: translations["Webpage"],
        icon: "fa fa-file",
        link: "/dash/web/webpages",
        selected: false,
        children: [],
        permissions: [
          Permissions.MANAGE_WEBSITE
        ]
      }
    ]
  },
  {
    title: translations["Quality Assurance"],
    expanded: true,
    icon: "fa fa-heart",
    items: [
      {
        title: translations["Attributes"],
        icon: "fa fa-filter",
        link: "/dash/inventory/attributes",
        selected: false,
        children: [],
        permissions: [
          Permissions.ADMINISTRATION
        ]
      }
    ]
  },
  {
    title: translations["Gamification"],
    expanded: true,
    icon: "fa fa-trophy",
    items: [
      {
        title: translations["Badge"],
        icon: "fa fa-filter",
        link: "/dash/badges",
        selected: false,
        children: [],
        permissions: [
          Permissions.ADMINISTRATION
        ]
      }
    ]
  },
  {
    title: translations["Social"],
    expanded: true,
    icon: "fa fa-users",
    items: [
      {
        title: translations["Notifications"],
        icon: "fa fa-filter",
        link: "/dash/notifications",
        selected: false,
        children: [],
        permissions: [
          Permissions.ADMINISTRATION
        ]
      },

      {
        title: translations["Feedbacks"],
        icon: "fa fa-filter",
        link: "/dash/feedbacks",
        selected: false,
        children: [],
        permissions: [
          Permissions.ADMINISTRATION
        ]
      },

    ]
  },
  {
    title: translations["Wallet"],
    expanded: true,
    icon: "fa fa-wallet",
    items: [
      {
        title: translations["My Wallet"],
        icon: "fa fa-wallet",
        link: "/dash/accounts/wallet",
        selected: false,
        children: [],
        permissions: [
          Permissions.ADMINISTRATION
        ]
      },
      {
        title: translations["Transaction Categories"],
        icon: "fa fa-list",
        link: "/dash/accounts/transaction-categories",
        selected: false,
        children: [],
        permissions: [
          Permissions.ADMINISTRATION
        ]
      }
    ]
  },
  {
    title: translations["Administration"],
    expanded: true,
    icon: "fas fa-cogs",
    items: [
      {
        title: translations["Organization"],
        icon: "fas fa-tag",
        link: "/dash/mdm/organizations",
        selected: false,
        children: [],
        permissions: [
          Permissions.ADMINISTRATION
        ]
      },
      {
        title: translations["Stores"],
        icon: "fa fa-filter",
        link: "/dash/inventory/vendors",
        selected: false,
        children: [],
        permissions: [
          Permissions.ADMINISTRATION
        ]
      },
      {
        title: translations["Client Apps"],
        icon: "fas fa-tag",
        link: "/dash/client-apps",
        selected: false,
        children: [],
        permissions: [
          Permissions.ADMINISTRATION
        ]
      },
      {
        title: translations["Labels"],
        icon: "fas fa-tag",
        link: "/dash/labels",
        selected: false,
        children: [],
        permissions: [
          Permissions.ADMINISTRATION
        ]
      },
      {
        title: translations["Users"],
        icon: "fas fa-users",
        link: environment.realm_admin_url,
        selected: false,
        children: [],
        permissions: [
          Permissions.ADMINISTRATION
        ]
      },
      {
        title: translations["Privileges"],
        icon: "fas fa-users",
        link: "/dash/users/privileges",
        selected: false,
        children: [],
        permissions: [
          Permissions.ADMINISTRATION
        ]
      },
      {
        title: translations["AllowedDomains"],
        icon: "fas fa-users",
        link: "/dash/allowed-domains",
        selected: false,
        children: [],
        permissions: [
          Permissions.ADMINISTRATION
        ]
      },
      {
        title: translations["Post"],
        icon: "fas fa-tag",
        link: "/dash/posts",
        selected: false,
        children: [],
        permissions: [
          Permissions.ADMINISTRATION
        ]
      },
      {
        title: translations["Search Histories"],
        icon: "fas fa-tag",
        link: "/dash/search-histories",
        selected: false,
        children: [],
        permissions: [
          Permissions.ADMINISTRATION
        ]
      },
      {
        title: translations["Activity Logs"],
        icon: "fas fa-tag",
        link: "/dash/users/activity-logs",
        selected: false,
        children: [],
        permissions: [
          Permissions.ADMINISTRATION
        ]
      },
      {
        title: translations["Location Types"],
        icon: "fas fa-tag",
        link: "/dash/mdm/location-types",
        selected: false,
        children: [],
        permissions: [
          Permissions.ADMINISTRATION
        ]
      },
      {
        title: translations["Locations"],
        icon: "fas fa-tag",
        link: "/dash/mdm/locations",
        selected: false,
        children: [],
        permissions: [
          Permissions.ADMINISTRATION
        ]
      },
      {
        title: translations["Addresses"],
        icon: "fas fa-tag",
        link: "/dash/mdm/addresses",
        selected: false,
        children: [],
        permissions: [
          Permissions.ADMINISTRATION
        ]
      },
      {
        title: translations["Crud Examples"],
        icon: "fas fa-tag",
        link: "/dash/crudexamples",
        selected: false,
        children: [],
        permissions: [
          Permissions.ADMINISTRATION
        ]
      }
    ]
  }
]
